router.$inject = ['$route'];

function router($route) {

  this.config = function($routeProvider) {
    $routeProvider
      .when('/', {
        template: '',
        controller: 'indexCtrl',
        page: 'index'
      })
      .when('/plans', {
        template: require('html/pages/routePlans'),
        controller: 'planCtrl',
        page: 'plans',
        title: 'pagePlans'
      })
      .when('/settings/driverUsers', {
        template: require('html/pages/settings/driverUsers'),
        controller: 'driverUsersCtrl',
        page: 'driverUsers',
        title: 'pageDrivers'
      })
      .when('/settings/users', {
        template: require('html/pages/settings/users'),
        controller: 'usersCtrl',
        page: 'users',
        title: 'pageUsers'
      })
      .when('/settings/cAcknowledgements', {
        template: require('html/pages/settings/companyAcknowledgements'),
        controller: 'settingsCtrl',
        page: 'settingsCompanyAcknowledgements',
        title: 'pageSettingsAcknowledgements'
      })
      .when('/settings/cNotifications', {
        template: require('html/pages/settings/companyNotifications'),
        controller: 'settingsCtrl',
        page: 'settingsCompanyNotifications',
        title: 'pageSettingsNotifications'
      })
      .when('/settings/cDeliveryTimes', {
        template: require('html/pages/settings/companyDeliveryTimes'),
        controller: 'settingsCtrl',
        page: 'settingsCompanyDeliveryTimes',
        title: 'pageSettingsDeliveryTimes'
      })
      .when('/settings/cGeneral', {
        template: require('html/pages/settings/companyGeneral'),
        controller: 'settingsCtrl',
        page: 'settingsCompanyGeneral',
        title: 'pageSettingsGeneral'
      })
      .when('/settings/csGeneral', {
        template: require('html/pages/settings/customerSystemGeneral'),
        controller: 'settingsCtrl',
        page: 'settingsCustomerSystemGeneral',
        title: 'pageSettingsGeneral'
      })
      .when('/settings/csAcknowledgements', {
        template: require('html/pages/settings/customerSystemAcknowledgements'),
        controller: 'settingsCtrl',
        page: 'settingsCustomerSystemAcknowledgements',
        title: 'pageSettingsAcknowledgements'
      })
      .when('/settings/csNotifications', {
        template: require('html/pages/settings/customerSystemNotifications'),
        controller: 'settingsCtrl',
        page: 'settingsCustomerSystemNotifications',
        title: 'pageSettingsNotifications'
      })
      .when('/settings/csDeliveryTimes', {
        template: require('html/pages/settings/customerSystemDeliveryTimes'),
        controller: 'settingsCtrl',
        page: 'settingsCustomerSystemDeliveryTimes',
        title: 'pageSettingsDeliveryTimes'
      })
      .when('/settings/diSystemWarnings', {
        template: require('html/pages/settings/diSystemWarnings'),
        controller: 'settingsCtrl',
        page: 'settingsSystemWarnings',
        title: 'pageSettingsSystemWarnings'
      })
      .when('/distributions', {
        template: require('html/pages/distributions'),
        controller: 'distributionCtrl',
        page: 'distributions',
        title: 'pageDistributions'
      })
      .when('/distribution/:date/:distrNo', {
        template: require('html/pages/distribution'),
        controller: 'distributionCtrl',
        page: 'distribution'
      })
      .when('/distribution/:date/:distrNo/routes', {
        template: require('html/pages/distributionRoutes'),
        controller: 'distributionCtrl',
        page: 'distribution/routes',
        title: 'pageDistributionRoutes'
      })
      .when('/distribution/:date/:distrNo/deviations', {
        template: require('html/pages/distributionCustomers'),
        controller: 'distributionCtrl',
        page: 'distribution/deviations',
        title: 'pageDistributionDeviations'
      })
      .when('/distribution/:date/:distrNo/search', {
        template: require('html/pages/distributionCustomers'),
        controller: 'distributionCtrl',
        page: 'distribution/search'
      })
      .when('/plan/files/:routePlanId', {
        template: require('html/pages/planFiles'),
        controller: 'planCustomersCtrl',
        page: 'plan/files',
        title: 'pageCustomers'
      })
      .when('/plan/customers/:routePlanId/:fileId?', {
        template: require('html/pages/planCustomers'),
        controller: 'planCustomersCtrl',
        page: 'plan/customers',
        title: 'pageCustomers'
      })
      .when('/plan/routes/map/:routePlanId', {
        template: require('html/pages/planRoutesMap'),
        controller: 'planRoutesCtrl',
        reloadOnSearch: false,
        page: 'plan/routes/map',
        title: 'pageRoutesMap'
      })
      .when('/plan/routes/list/:routePlanId', {
        template: require('html/pages/planRoutesList'),
        controller: 'planRoutesCtrl',
        page: 'plan/routes/list',
        title: 'pageRoutesList'
      })
      .when('/plan/reserveroutes/:routePlanId', {
        template: require('html/pages/planRoutesList'),
        controller: 'planRoutesCtrl',
        page: 'plan/routes/list',
        title: 'pageReserveRoutes',
        reserveRoutes: true
      })
      .when('/fleet/dashboard/list/:routePlanId', {
        template: require('html/pages/fleetDashboardList'),
        controller: 'fleetCtrl',
        page: 'fleet/dashboard/list',
        title: 'pageDashboardList'
      })
      .when('/fleet/dashboard/map/:routePlanId', {
        template: require('html/pages/fleetDashboardMap'),
        controller: 'fleetCtrl',
        reloadOnSearch: false,
        page: 'fleet/dashboard/map',
        title: 'pageDashboardMap'
      })
      .when('/fleet/deliveries/:routePlanId/:routeId?/:status?/:search?', {
        template: require('html/pages/fleetDeliveries'),
        controller: 'fleetCtrl',
        page: 'fleet/deliveries',
        title: 'pageCustomers'
      })
      .when('/fleet/print/:routePlanId/:routeId?', {
        template: require('html/pages/fleetPrint'),
        controller: 'fleetCtrl',
        page: 'fleet/print',
        title: 'pagePrint'
      })
      .when('/login', {
        template: require('html/pages/login'),
        controller: 'commonCtrl',
        page: 'login',
        title: 'pageLogin'
      })
      .otherwise({
        redirectTo: '/'
      });
  };

  this.page = function() {
    return $route.current.page;
  };

  this.title = function(page) {
    for (var path in $route.routes) {
      if ($route.routes[path].page === page) {
        return $route.routes[path].title;
      }
    }
  };

  this.link = function(page, routePlanId, distribution) {
    if (page === 'index') return '#/';
    else if (page === 'settingsUsers') return '#/settings/users';
    else if (page === 'settingsDriverUsers') return '#/settings/driverUsers';
    else if (page === 'settingsCompanyAcknowledgements') return '#/settings/cAcknowledgements';
    else if (page === 'settingsCompanyNotifications') return '#/settings/cNotifications';
    else if (page === 'settingsCompanyDeliveryTimes') return '#/settings/cDeliveryTimes';
    else if (page === 'settingsCompanyGeneral') return '#/settings/cGeneral';
    else if (page === 'settingsCustomerSystemGeneral') return '#/settings/csGeneral';
    else if (page === 'settingsCustomerSystemAcknowledgements') return '#/settings/csAcknowledgements';
    else if (page === 'settingsCustomerSystemNotifications') return '#/settings/csNotifications';
    else if (page === 'settingsCustomerSystemDeliveryTimes') return '#/settings/csDeliveryTimes';
    else if (page === 'settingsSystemWarnings') return '#/settings/diSystemWarnings';
    else if (page === 'distributions') return '/v2/distribution';
    else if (page === 'plans') return '/v2/plans';
    else if (page === 'deviation') return '/v2/deviation';
    else if (distribution) return '/v2/distribution/' + distribution.date + '/' + distribution.distrNo;
    else if (page === 'reserveroutes') return '#/plan/reserveroutes/' + routePlanId;
    return '#/' + page + '/' + routePlanId;
  };

  this.availablePages = function(routePlan) {
    if (! routePlan) return;

    if (routePlan.published) {
      return ['fleet/dashboard/list', 'fleet/dashboard/map', 'fleet/deliveries'];
    } else if (routePlan.routeCount) {
      return ['plan/routes/map', 'plan/routes/list', 'plan/customers'];
    } else if (routePlan.customerCount) {
      return ['plan/customers'];
    } else {
      return ['plan/files'];
    }
  };

  this.nextPage = function(routePlan) {
    return this.availablePages(routePlan)[0];
  };

}

module.exports = router;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/router.js
 ** module id = 204
 ** module chunks = 1
 **/